import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { LOGIN_URL, REGISTER_URL } from '../lib/links';

const LINKS = [
  { href: '#about', label: 'About' },
  { href: '#ecosystem', label: 'Ecosystem' },
  { href: '#income', label: 'Income Plan' },
  { href: '#activation', label: 'Activation' },
  { href: '#roadmap', label: 'Roadmap' },
];

export function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="nav">
      <div className="container nav-row">
        <a href="#top" className="brand" onClick={() => setOpen(false)}>
          <span className="brand-mark">
            <span>A</span>
          </span>
          <span>
            ALPHA ONE
            <small>Web3 Ecosystem</small>
          </span>
        </a>

        <nav className="nav-links">
          {LINKS.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>

        <div className="nav-cta">
          <a href={LOGIN_URL} className="btn btn-outline">
            Login
          </a>
          <a href={REGISTER_URL} className="btn btn-gold">
            Get Started
          </a>
          <button
            type="button"
            className="nav-toggle"
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open ? (
        <div className="nav-mobile">
          {LINKS.map((link) => (
            <a key={link.href} href={link.href} onClick={() => setOpen(false)}>
              {link.label}
            </a>
          ))}
        </div>
      ) : null}
    </header>
  );
}
